
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.099 10.715","height":"40.498","width":"34.391"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.876 5.324l.22 3.737c.054.908-.744 1.654-1.653 1.654H4.424c-.446 0-.868-.178-1.178-.492L0 6.923s.521-.508.538-.517a.505.505 0 01.575-.054c.016.005 1.781 1.018 1.781 1.018V2.445a.62.62 0 111.24 0V5.34h.194v-.018a.62.62 0 111.24 0v.018h.414v-.045a.62.62 0 01.62-.62c.343 0 .62.384.62.62v.045h.414v-.016a.62.62 0 111.24 0z"}}),_c('path',{attrs:{"d":"M1.562 4.922v-2.09H1.12v2.09H.458l.883.88.883-.88zM3.532.872c-.844 0-1.526.682-1.526 1.525h.436a1.09 1.09 0 012.18 0h.435c0-.843-.682-1.525-1.525-1.525zm0-.872a2.399 2.399 0 00-2.397 2.397h.435a1.961 1.961 0 013.923 0h.436A2.399 2.399 0 003.532 0z"}})])
          )
        }
      }
    